import React, { useState } from 'react';
import { createBooking } from '../api';

function fmt(iso, timezone) {
  return new Date(iso).toLocaleString([], {
    weekday: 'long', month: 'long', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
    timeZone: timezone || 'America/New_York',
    timeZoneName: 'short',
  });
}

export default function StepConfirm({ slug, booking, timezone, onBooked }) {
  const { service, staffName, slot, staffId } = booking;

  const [name,     setName]     = useState('');
  const [email,    setEmail]    = useState('');
  const [phone,    setPhone]    = useState('');
  const [dob,      setDob]      = useState('');
  const [errors,   setErrors]   = useState({});
  const [loading,  setLoading]  = useState(false);
  const [apiError, setApiError] = useState(null);

  const validate = () => {
    const e = {};
    if (!name.trim()) e.name = 'Name is required';
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Invalid email';
    return e;
  };

  const submit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true);
    setApiError(null);
    try {
      const result = await createBooking(slug, {
        serviceId:   service.id,
        staffId:     staffId || undefined,
        startAt:     slot,
        clientName:  name.trim(),
        clientEmail: email || null,
        clientPhone: phone || null,
        clientDob:   dob   || undefined,
      });
      // Hand result to App — it will move to payment step or done
      onBooked(result);
    } catch (err) {
      const msg = err.response?.data?.error?.message || 'Booking failed. Please try again.';
      setApiError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="w-title">Confirm booking</div>

      <div className="w-summary">
        <div className="w-summary-row">
          <span className="w-summary-label">Service</span>
          <span className="w-summary-value">{service.name}</span>
        </div>
        <div className="w-summary-row">
          <span className="w-summary-label">Staff</span>
          <span className="w-summary-value">{staffName}</span>
        </div>
        <div className="w-summary-row">
          <span className="w-summary-label">Date & Time</span>
          <span className="w-summary-value">{fmt(slot, timezone)}</span>
        </div>
        <div className="w-summary-row">
          <span className="w-summary-label">Duration</span>
          <span className="w-summary-value">{service.duration_minutes} min</span>
        </div>
        {service.price_cents > 0 && (
          <div className="w-summary-row">
            <span className="w-summary-label">Price</span>
            <span className="w-summary-value">${(service.price_cents / 100).toFixed(2)}</span>
          </div>
        )}
      </div>

      {apiError && <div className="w-error">{apiError}</div>}

      <div className="w-form">
        <div>
          <label className="w-label">Your name *</label>
          <input
            className={`w-input ${errors.name ? 'error' : ''}`}
            placeholder="Jane Smith"
            value={name}
            onChange={e => { setName(e.target.value); setErrors(v => ({ ...v, name: null })); }}
          />
          {errors.name && <div className="w-field-error">{errors.name}</div>}
        </div>
        <div>
          <label className="w-label">Email</label>
          <input
            className={`w-input ${errors.email ? 'error' : ''}`}
            type="email"
            placeholder="jane@example.com"
            value={email}
            onChange={e => { setEmail(e.target.value); setErrors(v => ({ ...v, email: null })); }}
          />
          {errors.email && <div className="w-field-error">{errors.email}</div>}
        </div>
        <div>
          <label className="w-label">Phone</label>
          <input
            className="w-input"
            type="tel"
            placeholder="+1 (555) 000-0000"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </div>
        <div>
          <label className="w-label">
            Date of Birth <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>(optional)</span>
          </label>
          <input
            className="w-input"
            type="date"
            value={dob}
            onChange={e => setDob(e.target.value)}
            max={new Date().toISOString().split('T')[0]}
          />
        </div>
      </div>

      <button
        className="w-btn w-btn-primary"
        onClick={submit}
        disabled={loading}
      >
        {loading ? 'Booking…' : 'Confirm booking'}
      </button>
    </>
  );
}
